import type { PdvDestaqueItem } from '@/shared/types';

export interface TextoDestaque {
  titulo: string;
  subtitulo: string | null;
  imagem_url: string | null;
  video_url: string | null;
}

const MAX_NOMES_SUBTITULO = 3;

export function montarTextoDestaque(itens: PdvDestaqueItem[]): TextoDestaque {
  if (itens.length === 0) return { titulo: '', subtitulo: null, imagem_url: null, video_url: null };
  const [principal, ...resto] = itens;
  const titulo = principal.quantidade > 1
    ? `${principal.quantidade}× ${principal.nome_exibicao} saíram nos últimos minutos`
    : (principal.frase?.trim() || `Saiu ${principal.nome_exibicao}`);
  // Muitos itens de uma vez (rodada grande): lista até 3 nomes e resume o resto,
  // senão o subtítulo não cabe numa linha da TV.
  const nomes = resto.slice(0, MAX_NOMES_SUBTITULO).map(item => item.nome_exibicao);
  const extras = resto.length - nomes.length;
  const subtitulo = resto.length === 0
    ? null
    : `e também ${nomes.join(', ')}${extras > 0 ? ` e mais ${extras}` : ''}`;
  return { titulo, subtitulo, imagem_url: principal.imagem_url, video_url: principal.video_url };
}
